import { produce } from "immer";
import { createReducer } from "typesafe-actions";
import "../../api/types.js";
import "moment-timezone";
import "react-intl";
import "@apollo/client/errors";
import "rxjs";
import "rxjs/operators";
import "@apollo/client";
import "graphql";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "fast-deep-equal/es6";
import "redux";
import { getEntityActions } from "../entity/actions.js";
import "../entity/epics.js";
import "normalizr";
import "../entity/EntityProvider.js";
import { getViewActions } from "./actions.js";
class ViewReducerCreator {
  _viewActions;
  _entityActions;
  constructor() {
    this._viewActions = getViewActions();
    this._entityActions = getEntityActions();
  }
  createReducer() {
    return createReducer(
      {}
    ).handleAction(this._viewActions.save, (state, action) => {
      const updatedState = produce(state, (draftState) => {
        const viewType = action.payload.view;
        if (draftState[viewType]) {
          draftState[viewType].entities[action.payload.entity.entity] = action.payload.entity;
          if (action.payload.realtime) {
            if (!draftState[viewType].realtime) {
              draftState[viewType].realtime = {};
            }
            draftState[viewType].realtime[action.payload.entity.entity] = action.payload.realtime;
          }
        } else {
          draftState[viewType] = {
            viewType,
            displayName: action.payload.displayName,
            entities: {
              [action.payload.entity.entity]: action.payload.entity
            }
          };
          if (action.payload.realtime) {
            draftState[viewType].realtime = {
              [action.payload.entity.entity]: action.payload.realtime
            };
          }
        }
      });
      return updatedState;
    }).handleAction(this._viewActions.changeIsInitialized, (state, action) => {
      const { view, entity, isInitialized } = action.payload;
      const updatedState = produce(state, (draftState) => {
        if (draftState?.[view]?.entities?.[entity]) {
          draftState[view].entities[entity].isInitialized = isInitialized;
        }
      });
      return updatedState;
    }).handleAction(this._viewActions.saveKeys, (state, action) => {
      const updatedState = produce(state, (draftState) => {
        const allViewEntityStates = Object.values(draftState).flatMap((i) => i.entities).flatMap((i) => Object.values(i));
        const updatedViewEntityStates = allViewEntityStates?.filter(
          (i) => i.entity === action.payload.entity && i.filter === action.payload.filter
        );
        updatedViewEntityStates?.forEach((viewEntityState) => {
          viewEntityState.keys = action.payload.keys;
          viewEntityState.total = action.payload.total;
        });
      });
      return updatedState;
    }).handleAction(this._viewActions.saveFilter, (state, action) => {
      const updatedState = produce(state, (draftState) => {
        const allViewEntityStates = Object.values(draftState).filter((i) => i.viewType === action.payload.view).flatMap((i) => i.entities).flatMap((i) => Object.values(i));
        const updatedViewEntityStates = allViewEntityStates?.filter((i) => i.entity === action.payload.entity);
        updatedViewEntityStates?.forEach((viewEntityState) => {
          viewEntityState.filter = action.payload.filter;
        });
      });
      return updatedState;
    }).handleAction(this._viewActions.clean, (state, action) => {
      const updatedState = produce(state, (draftState) => {
        const viewType = action.payload.view;
        delete draftState[viewType];
      });
      return updatedState;
    }).handleAction(this._entityActions.fetchStatus, (state, action) => {
      const updatedState = produce(state, (draftState) => {
        const { entityType, filter, requestStatus } = action.payload;
        const viewEntityStates = Object.values(draftState).flatMap((i) => i.entities).flatMap((i) => Object.values(i)).filter((i) => i.entity === entityType && i.filter === filter);
        viewEntityStates.forEach((i) => i.status = requestStatus);
      });
      return updatedState;
    }).handleAction(this._viewActions.updateCleanDelay, (state, action) => {
      const updatedState = produce(state, (draftState) => {
        const { view, cleanDelay } = action.payload;
        const stateCleanDelay = state[view].cleanDelay ?? 0;
        draftState[view].cleanDelay = Math.max(cleanDelay, stateCleanDelay);
      });
      return updatedState;
    });
  }
}
export {
  ViewReducerCreator
};
//# sourceMappingURL=reducers.js.map
